import { render } from "./FormCallcenter.vue?vue&type=template&id=34572046&scoped=true"
import script from "./formcallcenter.view.js?vue&type=script&lang=js&external"
export * from "./formcallcenter.view.js?vue&type=script&lang=js&external"

import "./formcallcenter.css?vue&type=style&index=0&id=34572046&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34572046"]])

export default __exports__